// extracted by mini-css-extract-plugin
export default {"contentContainer":"CreateContent_contentContainer__bhXIC"};